var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import TreeSelect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import GoodAdd from './GoodAdd.vue';
import ThirdPartySystemService from '../../../api/ThirdPartySystemService';
import { clone } from 'lodash';
import { UrlHelper } from '../../../helper/UrlWrapper';
import { mapGetters } from 'vuex';
var ScmDialog = (function (_super) {
    __extends(ScmDialog, _super);
    function ScmDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.good_init_params = {};
        _this.activeStep = 0;
        _this.loading = false;
        _this.systemName = '';
        _this.errors = [];
        _this.is_synced = false;
        _this.showProcessing = false;
        _this.activeTab = 'unselected';
        _this.selectedGoodsList = [];
        _this.shopList = [];
        _this.form = {
            api_url: '',
            username: '',
            pwd: ''
        };
        _this.rules = {
            api_url: [
                { required: true, message: '请输入供应链系统地址', trigger: 'blur' },
                {
                    validator: function (rule, value, callback) {
                        if (!value) {
                            callback();
                            return;
                        }
                        var url = value;
                        try {
                            new URL(url);
                            callback();
                        }
                        catch (e) {
                            callback(new Error('请输入有效的系统地址'));
                        }
                    },
                    trigger: 'blur'
                }
            ],
            username: [
                { required: true, message: '请输入登录账号', trigger: 'blur' }
            ],
            pwd: [
                { required: true, message: '请输入密码', trigger: 'blur' }
            ]
        };
        _this.syncItems = [];
        _this.oriSyncItems = [];
        _this.syncResults = [];
        _this.baseUrl = window.location.origin + '/supplierclientapi/agent_warehouse/export_error?import_id=';
        return _this;
    }
    ScmDialog.prototype.getSyncIcon = function (status) {
        switch (status) {
            case 'success':
                return 'el-icon-circle-check';
            case 'error':
                return 'el-icon-error';
            case 'loading':
                return 'el-icon-loading';
            default:
                return 'el-icon-info';
        }
    };
    ScmDialog.prototype.onValueChange = function (val) {
        this.visible = val;
    };
    ScmDialog.prototype.onVisibleChange = function (val) {
        this.$emit('input', val);
    };
    Object.defineProperty(ScmDialog.prototype, "visible", {
        get: function () {
            return this.value;
        },
        set: function (val) {
            this.$emit('input', val);
        },
        enumerable: true,
        configurable: true
    });
    ScmDialog.prototype.verifyScmUserPermission = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.loading = true;
                return [2, this.service.verifyScmUserPermission({ data: data }).then(function (res) {
                        _this.oriSyncItems.push({ name: '授权成功', status: 'success', detail: '' });
                        _this.systemName = res.data.data.shopName;
                        _this.activeStep++;
                        _this.good_init_params = {
                            api_url: data.api_url
                        };
                        _this.$nextTick(function () {
                            _this.$refs.goodAdd.getGoodList();
                            _this.$refs.goodAdd.getCategory();
                            _this.$refs.goodAdd.getShopList();
                        });
                    }).catch(function (error) {
                        _this.$message.error(error.message);
                    }).finally(function () {
                        _this.loading = false;
                    })];
            });
        });
    };
    ScmDialog.prototype.executeSync = function (name, syncFn) {
        return __awaiter(this, void 0, void 0, function () {
            var res, currentItem, data, detail, downloadUrl, total_shop_count, error_1, currentItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.syncItems.push({ name: name, status: 'loading', detail: '' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, syncFn()];
                    case 2:
                        res = _a.sent();
                        currentItem = this.syncItems[this.syncItems.length - 1];
                        if (!res.data.success) {
                            currentItem.status = 'error';
                            currentItem.detail = res.data.msg;
                            return [2, false];
                        }
                        data = res.data.data;
                        detail = '';
                        downloadUrl = '';
                        console.log('name :>> ', name);
                        console.log('data :>> ', data);
                        if (name === '同步货品') {
                            detail = "\u6210\u529F <span style=\"color: #67C23A;\">" + data.success_count + "</span> \u4E2A\uFF0C\u5931\u8D25 <span style=\"color: red;\">" + data.fail_count + "</span> \u4E2A";
                            if (data.fail_count > 0 && data.import_id) {
                                downloadUrl = this.baseUrl + data.import_id;
                                downloadUrl = UrlHelper.addParam(downloadUrl, 'token', this.user.token);
                            }
                        }
                        else if (name === '同步门店档案和配送中心') {
                            total_shop_count = data.shop_success_count + data.shop_fail_count;
                            detail = "\uFF08\u5171\u8BA1" + total_shop_count + "\u5BB6\u95E8\u5E97\uFF09 \u95E8\u5E97\u6210\u529F <span style=\"color: #67C23A;\">" + data.shop_success_count + "</span> \u4E2A\uFF0C\u5931\u8D25 <span style=\"color: red;\">" + data.shop_fail_count + "</span> \u4E2A\uFF1B\u4ED3\u5E93\u6210\u529F <span style=\"color: #67C23A;\">" + data.dept_success_count + "</span> \u4E2A\uFF0C\u5931\u8D25 <span style=\"color: red;\">" + data.dept_fail_count + "</span> \u4E2A";
                            if ((data.shop_fail_count > 0 || data.dept_fail_count > 0) && data.import_id) {
                                downloadUrl = this.baseUrl + data.import_id;
                                downloadUrl = UrlHelper.addParam(downloadUrl, 'token', this.user.token);
                            }
                        }
                        currentItem.status = 'success';
                        currentItem.detail = detail;
                        if (downloadUrl) {
                            currentItem.downloadUrl = downloadUrl;
                        }
                        return [2, true];
                    case 3:
                        error_1 = _a.sent();
                        currentItem = this.syncItems[this.syncItems.length - 1];
                        currentItem.status = 'error';
                        currentItem.detail = error_1.message;
                        return [2, false];
                    case 4: return [2];
                }
            });
        });
    };
    ScmDialog.prototype.getSyncShops = function (list) {
        return list.filter(function (item) { return item.sid; });
    };
    ScmDialog.prototype.syncData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var syncTasks, _i, syncTasks_1, task, success;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.syncItems = clone(this.oriSyncItems);
                        this.syncResults = [];
                        syncTasks = [
                            {
                                name: '同步授权信息',
                                fn: function () { return _this.syncScmConfig(_this.form); }
                            },
                            {
                                name: '同步货品',
                                fn: function () { return _this.syncScmGoods(_this.selectedGoodsList); }
                            },
                            {
                                name: '同步门店档案和配送中心',
                                fn: function () { return _this.syncScmShop(_this.getSyncShops(_this.shopList)); }
                            },
                        ];
                        _i = 0, syncTasks_1 = syncTasks;
                        _a.label = 1;
                    case 1:
                        if (!(_i < syncTasks_1.length)) return [3, 4];
                        task = syncTasks_1[_i];
                        return [4, this.executeSync(task.name, task.fn)];
                    case 2:
                        success = _a.sent();
                        if (!success) {
                            this.loading = false;
                            return [2];
                        }
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3, 1];
                    case 4:
                        this.syncItems.push({ name: '同步完成', status: 'success', detail: '' });
                        this.is_synced = true;
                        this.showProcessing = false;
                        this.loading = false;
                        return [2];
                }
            });
        });
    };
    ScmDialog.prototype.syncScmConfig = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.service.syncScmConfig({ data: data })];
            });
        });
    };
    ScmDialog.prototype.handleCancel = function () {
        this.visible = false;
        this.resetAll();
    };
    ScmDialog.prototype.handleNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isValid_1, selectedGoodsList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.activeStep === 0)) return [3, 3];
                        isValid_1 = false;
                        return [4, this.$refs.authForm.validate(function (valid) {
                                isValid_1 = valid;
                            })];
                    case 1:
                        _a.sent();
                        if (!isValid_1) {
                            this.$message.error('请正确填写表单信息');
                            return [2];
                        }
                        return [4, this.verifyScmUserPermission(this.form)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        if (this.activeStep === 1) {
                            selectedGoodsList = this.$refs.goodAdd.getSelectedList();
                            if (!selectedGoodsList.length) {
                                this.$message.warning('请至少选择一个商品');
                                return [2];
                            }
                            this.selectedGoodsList = selectedGoodsList;
                            this.shopList = this.$refs.goodAdd.shopList;
                            this.oriSyncItems.push({ name: '选择同步货品档案的范围', status: 'success', detail: selectedGoodsList.length + "\u4E2A\u8D27\u54C1" });
                            this.syncItems = clone(this.oriSyncItems);
                            this.activeStep++;
                        }
                        else if (this.activeStep === 2) {
                            if (this.is_synced) {
                                this.activeStep++;
                            }
                            else {
                                this.showProcessing = true;
                                this.syncData();
                            }
                        }
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    ScmDialog.prototype.syncScmGoods = function (goods) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.service.syncScmGoods({ data: { goods: goods } })];
            });
        });
    };
    ScmDialog.prototype.syncScmShop = function (shop) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.service.syncScmShop({ data: { shop: shop } })];
            });
        });
    };
    ScmDialog.prototype.updateInitStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.service.updateInitStatus()];
                    case 1:
                        _a.sent();
                        this.$message.success('初始化状态更新成功');
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.$message.error(error_2.message || '初始化状态更新失败');
                        throw error_2;
                    case 3: return [2];
                }
            });
        });
    };
    ScmDialog.prototype.resetAll = function () {
        this.activeStep = 0;
        this.errors = [];
        this.selectedGoodsList = [];
        this.shopList = [];
        var authForm = this.$refs.authForm;
        if (authForm) {
            authForm.resetFields();
        }
        this.$refs.goodAdd.resetAll();
        this.syncItems = [];
        this.oriSyncItems = [];
        this.syncResults = [];
        this.is_synced = false;
    };
    ScmDialog.prototype.handleComplete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.is_synced) return [3, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.updateInitStatus()];
                    case 2:
                        _a.sent();
                        this.$emit('submit');
                        this.visible = false;
                        this.resetAll();
                        return [3, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('Failed to update init status:', error_3);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    ScmDialog.prototype.created = function () {
        this.service = ThirdPartySystemService.getInstance();
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], ScmDialog.prototype, "value", void 0);
    __decorate([
        Watch('value')
    ], ScmDialog.prototype, "onValueChange", null);
    __decorate([
        Watch('visible')
    ], ScmDialog.prototype, "onVisibleChange", null);
    ScmDialog = __decorate([
        Component({
            components: {
                'tree-select': TreeSelect,
                'good-add': GoodAdd
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], ScmDialog);
    return ScmDialog;
}(Vue));
export default ScmDialog;
